<template>
  <div class="ayuda">
    <headNav :activeNav="'FAQ'"></headNav>
    <div class="banner"></div>

    <div class="bigContent">
      <div class="content">
        <ul class="btnList">
          <li
            v-for="item in btnList"
            :key="item.id"
            :class="item.id == changeBtn ? 'is-active' : ''"
          >
            <button @click="changeCont(item.id)">{{ item.label }}</button>
          </li>
        </ul>
        <div style="flex: 1; padding-top: 40px" v-if="changeBtn == 1">
          <el-collapse v-model="activeNames">
            <el-collapse-item :name="1">
              <template slot="title">
                <transition name="slide-fade">
                  <div
                    class="collapseDiv"
                    :class="activeNames.indexOf(1) > -1 ? 'activeTitle' : ''"
                  >
                    <div class="icon">
                      <img src="../assets/image/symbol/1.webp" />
                      <p>Trámites indispensables:</p>
                    </div>
                    <img
                      class="iconArrow"
                      v-if="activeNames.indexOf(1) == -1"
                      src="../assets/image/symbol/iconBottom.webp"
                    />
                    <img
                      class="iconArrow"
                      v-if="activeNames.indexOf(1) > -1"
                      src="../assets/image/symbol/iconTop.webp"
                    />
                  </div>
                </transition>
              </template>
              <div class="collapseCont">
                <p>1) Tener su C.C.ID en la mano</p>
                <p>
                  2) Tener una cuenta de débito de CUALQUIER banco y que esté a
                  SU nombre
                </p>
                <p>3) Llenar su solicitud en la aplicación</p>
                <p>
                  NOTA: Recuerde que no pedimos ninguna clase de anticipos y que
                  la única forma de hacer su solicitud es por medio de la
                  aplicación. TODO EL PROCESO ES GRATUITO.
                </p>
                <p>Nota:</p>
                <p>Indispensable ser mayor de 18 años.</p>
              </div>
            </el-collapse-item>
            <el-collapse-item :name="2">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(2) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/2.webp" />

                    <p>¿Qué puedo hacer si falla el depósito?</p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(2) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(2) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                Estimado cliente, en este caso puede intentar comprobar si hay
                un error en el préstamo, o hay un problema con la recepción de
                su cuenta, y si el estado de su cuenta bancaria es normal. Si
                tiene circunstancias especiales, puede contactarnos al
                <span style="color:#FE7632">+57 3134290542</span> de 9:00 a
                18:00 en horario laboral Le proporcionaremos la información más
                detallada y le brindaremos servicios más personalizados.
              </div>
            </el-collapse-item>
            <el-collapse-item :name="3">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(3) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/3.webp" />
                    <p>¿Puedo incrementar mi monto de préstamo?</p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(3) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(3) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                En Dinerbacano, queremos asegurarnos de que nuestros clientes
                tengan acceso a los mejores productos de préstamo posibles. Por
                esta raz￳ón, ofrecemos múltiples opciones de préstamos para los
                usuarios con buen historial crediticio. Esto significa que
                puedes solicitar varios préstamos a la vez, siempre y cuando
                tengas la capacidad de hacer los pagos correspondientes en su
                debido tiempo, tal como está establecido en nuestros términos y
                condiciones.
              </div>
            </el-collapse-item>
            <el-collapse-item :name="4">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(4) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/4.webp" />
                    <p>¿Por qué me han rechazado?</p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(4) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(4) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                <p>
                  En Dinerbacano, nos tomamos muy en serio el proceso de
                  aprobació￳n de préstamos y nos entristece escuchar que tu
                  solicitud ha sido rechazada. Queremos aclarar que nuestro
                  proceso de aprobaci￳ón es automático y está basado en las
                  informaciones que nos proporcionas en tu solicitud.
                </p>
                <p>
                  Hay varios motivos por los cuales una solicitud de préstamo
                  puede ser rechazada, como fotos borrosas, informaciones
                  incompletas o falta de documentaci￳n de acceso. Sin embargo,
                  también es posible que una solicitud sea rechazada debido a
                  que nuestro sistema detecta que el usuario no podrá manejar
                  una carga financiera adicional.
                </p>
                <p>
                  Nos esforzamos por ser responsables y cuidadosos en cada una
                  de nuestras aprobaciones de préstamos, y nuestra prioridad es
                  asegurarnos de que nuestros usuarios puedan manejar sus
                  obligaciones financieras de manera efectiva. Nos disculpamos
                  por cualquier inconveniente que esto haya causado y nos
                  gustaría ofrecerte asesoramiento personalizado para ayudarte a
                  entender las razones detrás de tu rechazo, así como a buscar
                  otras opciones de financiamiento que puedan ser adecuadas para
                  ti. No dudes en contactar con nuestro equipo de soporte para
                  obtener más informaciones.
                </p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div style="flex: 1; padding-top: 40px" v-if="changeBtn == 2">
          <el-collapse v-model="activeNames">
            <el-collapse-item :name="1">
              <template slot="title">
                <transition name="slide-fade">
                  <div
                    class="collapseDiv"
                    :class="activeNames.indexOf(1) > -1 ? 'activeTitle' : ''"
                  >
                    <div class="icon">
                      <img src="../assets/image/symbol/1.webp" />
                      <p>¿Cómo pago mi préstamo en línea?</p>
                    </div>
                    <img
                      class="iconArrow"
                      v-if="activeNames.indexOf(1) == -1"
                      src="../assets/image/symbol/iconBottom.webp"
                    />
                    <img
                      class="iconArrow"
                      v-if="activeNames.indexOf(1) > -1"
                      src="../assets/image/symbol/iconTop.webp"
                    />
                  </div>
                </transition>
              </template>
              <div class="collapseCont">
                <p>1. Ingresar en Dinerbacano e iniciar sesión;</p>
                <p>2. Dar clic en el botón "PSE" en la página de pago;</p>
                <p>3. Rellenar el monto de pago y los datos personales;</p>
                <p>
                  4. Dar clic en "Confirmar", y entrar en la página de banco
                  automáticamente para pagar el préstamo.
                </p>
              </div>
            </el-collapse-item>
            <el-collapse-item :name="2">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(2) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/2.webp" />

                    <p>¿Cómo pago mi préstamo en efectivo?</p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(2) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(2) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                <p>1. Ingresar en Dinerbacano e iniciar sesión;</p>
                <p>2. Dar clic en el botón "Efectivo" en la página de pago;</p>
                <p>3. Elegir un convenio más cercana;</p>
                <p>
                  4. Dar clic en el botón "Pagar", y revisar la referencia de
                  pago de la tienda;
                </p>
                <p>
                  5. Mostrar la referencia de pago al dependiente y pagar el
                  préstamo.
                </p>
              </div>
            </el-collapse-item>
            <el-collapse-item :name="3">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(3) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/3.webp" />
                    <p>Pagué en exceso por fallo ¿qué hago?</p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(3) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(3) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                Lamentamos cualquier problema que hayas tenido con respecto al
                pago de tu pedido. No se preocupe, el dinero en exceso se
                depositará automáticamente en el saldo de su cuenta de
                Dinerbacano y se puede utilizar para el pago.
              </div>
            </el-collapse-item>
            <el-collapse-item :name="4">
              <template slot="title">
                <div
                  class="collapseDiv"
                  :class="activeNames.indexOf(4) > -1 ? 'activeTitle' : ''"
                >
                  <div class="icon">
                    <img src="../assets/image/symbol/4.webp" />
                    <p>
                      ¿Qué hago si tengo una queja?
                    </p>
                  </div>
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(4) == -1"
                    src="../assets/image/symbol/iconBottom.webp"
                  />
                  <img
                    class="iconArrow"
                    v-if="activeNames.indexOf(4) > -1"
                    src="../assets/image/symbol/iconTop.webp"
                  />
                </div>
              </template>
              <div class="collapseCont">
                Nos disculpamos por cualquier problema que hayas experimentado
                con nuestros servicios y nos gustaría ofrecerte nuestra ayuda
                para resolverlo. Por favor, contáctanos a través de nuestro
                Servicio de Atenci￳ón al Cliente,
                <span style="color:#FE7632">+57 3134290542</span>
                de 9:00 a 18:00 en horario labora, donde podrás explicarnos los
                detalles de tu reclamació￳n y proporcionar cualquier prueba
                relevante que puedas tener. Por favor, asegúrate de compartir
                toda la informaci￳ón relevante, como tu número de pedido, ID de
                usuario y cualquier otra informaci￳ón que pueda ayudarnos a
                identificar tus necesidades y brindarte la mejor soluci￳ón
                posible.
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/ayuda.scss";
import infoList from "@/mixins/infoList";

export default {
  name: "ayuda",
  components: { headNav, footPage },
  mixins: [infoList],

  data() {
    return {
      activeNames: [],
      changeBtn: 1,
      btnList: [
        {
          label: "Preguntas sobre solicitudes de préstamo",
          id: 1,
        },
        {
          label: "Preguntas sobre el pago de préstamo",
          id: 2,
        },
      ],
    };
  },
  watch: {
    changeBtn() {
      this.activeNames = [];
    },
  },
  methods: {
    changeCont(id) {
      this.changeBtn = id;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
